import { Feature, Polygon } from "geojson"

export interface IGeofence {
    _id?: string // This _id belongs to a geofence mongoId which is generated by the database
    properties: {
        name?: string
        entryNotifications?: boolean
        exitNotifications?: boolean
        toggleSpeed?: boolean
        speed?: number | null
        type?: string
        entity?: string
        entityId?: string
        __typename?: string
    }
    geometry: {
        coordinates: [[[number]]]
        type?: string
    }
    __typename?: string
    id?: string // This id belongs to a featureId which is generated by mapBox library
}

export interface IGeofencePolygonWithBBox {
    id: string
    boundingBox: { minX: number; minY: number; maxX: number; maxY: number }
    polygon: Feature<Polygon> // More explicit type
    entryNotifications: boolean
    exitNotifications: boolean
}
export interface IGeofenceCoordinates {
    id: string
    coordinates: [number, number][]
    entryNotifications: boolean
    exitNotifications: boolean
}

export interface IBoundingBox {
    minX: number
    minY: number
    maxX: number
    maxY: number
}

export enum EGeofenceEventType {
    ENTER = "ENTER",
    EXIT = "EXIT",
}

export interface IGeoJsonPoint {
    type?: "Point"
    coordinates: [number, number]
}
